import React, { useEffect, useState } from 'react';
import CircularProgressbar from "react-circular-progressbar";
import IntlMessages from '../../../../../helpers/IntlMessages';

const Percentage = ({ data }) => {
  const [percentageData, setPercentageData] = useState([]);
  useEffect(() => {
    var list = [];
    Object.keys(data).filter(per => per !== "amenties" && per !== "bookings" && per !== "websiteChat" && per !== "facebookChat")
      .map((x) => {
        if (x === "trafficAvatarClick") {
          list.push({
            label: x,
            value: data[x],
            order: 1
          })
        }
        if (x === "trafficChatConversion") {
          list.push({
            label: x,
            value: data[x],
            order: 2
          })
        }
        if (x === "understandingAccuracy") {
          list.push({
            label: x,
            value: data[x],
            order: 3
          })
        }
        if (x === 'negativeFeedback') {
          list.push({
            label: x,
            value: data[x],
            order: 4
          })
        }
      });
    setPercentageData(list.sort((a, b) => a.order - b.order))
  }, [data]);
  const getLabel = (lab) => {
    switch (lab.toLowerCase()) {
      case "understandingaccuracy":
        return "dashboards.percentage-accuracy";

      case "trafficchatconversion":
        return "dashboards.percentage-conversion";

      case "amenties":
        return "dashboards.percentage-amenties";

      case "bookings":
        return "dashboards.percentage-booking";

      case "websitechat":
        return "dashboards.percentage-webchats";

      case "facebookchat":
        return "dashboards.percentage-facebookchat";

      case "trafficavatarclick":
        return "dashboards.percentage-avatarclick";

      case "negativefeedback":
        return "dashboards.percentage-negativefeedback";
    }
    return lab
  };

  return (
    <div className="row">
      {percentageData.map((per, index) =>
        <div className="mb-4 col-lg-3 col-xl-3" key={index}>
          <div className="card">
            <div className="d-flex justify-content-between align-items-center card-body">
              <p><IntlMessages id={getLabel(per.label)} /> </p>
              <div className="progress-bar-circle">
                <CircularProgressbar
                  strokeWidth={4}
                  percentage={per.value > 0 ? per.value : 0}
                  text={per.value > 0 ? per.value + "%" : "0%"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div >
  );
};

export default Percentage;
